import isObject from "modules/isObject";

export default (obj) => isObject(obj) && Object.keys(obj).length > 0;
